import { FiUser, FiLayers } from "react-icons/fi";
import { strings } from "../../../strings/strings";

export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getContactViewModalSections = (request) => {
  if (!request) return [];

  return [
    {
      title: strings.PERSONAL_INFORMATION,
      icon: FiUser,
      iconBg: "bg-blue-100 dark:bg-blue-900/30",
      iconColor: "text-blue-600 dark:text-blue-400",
      fields: [
        { label: strings.CONTACT_NAME, value: `${request.firstName} ${request.lastName}` },
        { label: strings.CONTACT_EMAIL, value: request.businessEmail },
        { label: strings.CONTACT_PHONE, value: request.mobileNumber ? `${request.mobileCode} ${request.mobileNumber}` : "N/A" },
        { label: strings.CONTACT_DATE, value: formatDate(request.createdAt) },
        { 
          label: "Status", 
          value: request.status, 
          badge: true, 
          badgeClass: request.status === 'pending' 
            ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400' 
            : 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
        },
      ],
    },
    {
      title: strings.COMPANY_DETAILS,
      icon: FiLayers,
      iconBg: "bg-purple-100 dark:bg-purple-900/30",
      iconColor: "text-purple-600 dark:text-purple-400",
      fields: [
        { label: strings.CONTACT_COMPANY, value: request.companyName || "N/A" },
        { label: strings.CONTACT_EMPLOYEE_COUNT, value: request.numberOfEmployees || "N/A" },
        { label: strings.CONTACT_SOURCE, value: request.howDidYouHear || "N/A" },
      ],
    },
  ];
};
